module.exports = __webpack_public_path__ + "./stella_5fdd01dd690e50e08fb7df1fde025ef0.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2015/stella.png
// module id = 427
// module chunks = 0